import CommonUpload from './CommonUpload.vue'
export default CommonUpload
